import * as React from 'react';

import { cn } from '@/lib/utils';

/*
 * Restyled to ScreenAtlas tokens (web/docs/ui-ux.md §5) — the Textarea sibling
 * of the token-restyled Input: the border is the input's job, `surface` fill
 * against the canvas, no shadow, the app-wide :focus-visible ring, and a
 * danger border on `aria-invalid` (errors are announced, not colour-only).
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[96px] w-full rounded border border-border bg-surface px-3 py-2.5 text-body text-ink shadow-highlight transition-colors',
          'placeholder:text-ink-tertiary disabled:cursor-not-allowed disabled:opacity-50',
          'aria-[invalid=true]:border-danger',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
